module.exports = __webpack_public_path__ + "img/22.1b5aecf6.png";